import { bemClassesFromModifiers } from "../../constants/misc";
import React from "react";

const MoveBoxWrapper = (props) => {
  const {
    isDown,
    minified,
    externalWindow,
    className,
    children,
    fullscreenMobile,
  } = props;
  return (
    <div
      className={
        bemClassesFromModifiers("moveBox", [
          isDown ? "moving" : null,
          minified ? "minified" : null,
          externalWindow ? "external" : null,
          fullscreenMobile ? "fullscreenMobile" : null,
        ]) +
        " " +
        className
      }
    >
      {children}
    </div>
  );
};

export default MoveBoxWrapper;
